import { CommandManagerAPI, CommandManagerCommandCallback, StringKeyDictionary } from "../../commonInterfaces.js";
import { Helper } from "./helper.js";

export enum Commands {
    RELOADDATASOURCE, DYNAMIC, REFRESH, RELOADVALUE
}

export class CommandManager {
    public static create = () => {
        return (() => {
            const executors: StringKeyDictionary<Array<CommandManagerCommandCallback>> = {};
            const history: StringKeyDictionary<{ command: Commands, data: any }> = {};

            const api: CommandManagerAPI = {
                registerExecutor: (identifier, callback, callIfAlreadyRun = false) => {
                    if (!Helper.hasValue(executors[identifier])) {
                        executors[identifier] = [];
                    }
                    executors[identifier].push(callback);
                    if (callIfAlreadyRun && history[identifier]) {
                        callback(history[identifier].command, history[identifier].data);
                    }
                },
                runCommand: function (identifier, command, data) {
                    if (executors[identifier]) {
                        executors[identifier].forEach((callback, index) => {
                            callback(command, data);
                        });
                    }
                    history[identifier] = { command: command, data: data };
                }
            };

            return api;
        })();
    }
}